import axios from 'axios';


const getSalesMembership = async(formdetails,page,records) =>{
    console.log("service" , formdetails)
    const formdata = {
        filters : formdetails,
        page : page,
        records : records
    }
    const response = await axios.post('/api/sales-membership/get-sales-membership',formdata);
    console.log(response.data)
    return response.data;
}

const getDetails = async (id) => {
    console.log(id)
    const response = await axios.get(`/api/sales-membership/details/${id}`);
    console.log(response.data)
    return response.data;
}

const getTotalTxnAmount = async(formdetails) =>{
   console.log("service" , formdetails)
    const formdata = {
        filters : formdetails,
    }
    const response = await axios.post('/api/sales-membership/get-total-amount',formdata);
    console.log(response.data)
    return response.data;
}
 
const getTotalSales = async(formdetails) =>{
  
     const formdata = {
         filters : formdetails,
     }
     const response = await axios.post('/api/sales-membership/get-total-sales',formdata);
     console.log(response.data)
     return response.data;
 }

 const getAllPaymentGateways = async() =>{
    const response = await axios.get('/api/sales-membership/get-payment-gateways');
    console.log(response.data)
    return response.data;
}

const getTotalTxnAmountByCurrency = async(formdetails) =>{
   console.log("service getTotalTxnAmountByCurrency" , formdetails)
    const formdata = {
        filters : formdetails,
    }
    const response = await axios.post('/api/sales-membership/get-total-amount-by-currency',formdata);
    console.log(response.data)
    return response.data;
}
 
const getAllPlanId = async() =>{
    const response = await axios.get('/api/subscription-membership/get-plan-id');
    console.log(response.data)
    return response.data;
}

const exportSales = async (formdata) => {
    try {
        const response = await axios.post('/api/sales-membership/export-sales-membership',formdata,{
            responseType : 'arraybuffer'
        });
        console.log("response",response);
        return response;
    } catch (error) {
        console.error('Error in exporting users:', error.message || error);
        throw new Error('Failed to export users. Please try again later.');
    }
};

const getShareAmount = async(formdetails) =>{
  
     const formdata = {
         filters : formdetails,
     }
     const response = await axios.post('/api/sales-membership/get-share-amount',formdata);
     console.log(response.data)
     return response.data;
 }

 const getActiveSubscribers = async(formdetails) =>{
     const formdata = {
         filters : formdetails,
     }
     const response = await axios.post('/api/sales-membership/get-active-subscribers',formdata);
     console.log(response.data)
     return response.data;
 }

 const getPlanWiseSales = async(formdetails) =>{
    const formdata = {
        filters : formdetails,
    }
    const response = await axios.post('/api/sales-membership/get-plan-wise-sales',formdata);
    console.log(response.data)
    return response.data;
}


export default {
    getSalesMembership,
    getDetails,
    getTotalTxnAmount,
    getTotalTxnAmountByCurrency,
    getTotalSales,
    getAllPaymentGateways,
    getAllPlanId,
    exportSales,
    getShareAmount,
    getActiveSubscribers,
    getPlanWiseSales
}